
import {createConnector} from 'edotw-client';
import { GRAPHQL_ENDPOINT } from '../config';

export default createConnector({endpoint: GRAPHQL_ENDPOINT, fetch});
